// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S9WN_","col":"styles_col__2OYuy","actions":"styles_actions__flCt1","conflict":"styles_conflict__32yi2"};